import React from "react"
import Img from "gatsby-image"
import styled from "styled-components"

import Layout from "../components/layout"
import SEO from "../components/seo"
import style from "./index.module.css"

const NeuWrapper = styled.div`
  margin-bottom: 2rem;
  padding: 2rem 2rem 1rem;
  border-radius: 1rem;
  background: #ffffff;
  box-shadow: 1rem 1rem 3rem hsla(0, 0%, 100%, 0.2), -1rem -1rem 3rem #ffffff;
`
const PageHeader = styled.h1`
  text-align: center;
`

const IndexPage = ({ data }) => {
  return (
    <Layout>
      <SEO
        title="Probiotics Introduction"
        description="A simple introduction to probiotics."
        image="/logo.png"
        pathname="/"
        // Boolean indicating whether this is an article:
        // article
      />
      <section className={style.wrapper}>
        <Img
          className={style.headerImage}
          fluid={data.headerImage.childImageSharp.fluid}
          alt="Human Transformation"
        />
        <PageHeader className={style.heading}>What are probiotcs?</PageHeader>
        <NeuWrapper>
          <p>
            Probiotics are "good" bacteria touted to help maintain digestive
            health and boost the immune system. You can take them in a dietary
            supplement or get them from food sources, such as yogurt. But should
            you?
          </p>
          <p>
            Bacteria have a reputation for causing disease, so the idea of
            tossing down a few billion a day for your health might seem —
            literally and figuratively — hard to swallow. But a growing body of
            scientific evidence suggests that you can treat and even prevent
            some illnesses with foods and supplements containing certain kinds
            of live bacteria.
          </p>
        </NeuWrapper>
      </section>
    </Layout>
  )
}

export default IndexPage

export const query = graphql`
  {
    headerImage: file(relativePath: { eq: "front-banner-1600.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1184) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
